import React from 'react'
import HeroSection from './heroSection'
import History from './history'
import Journey from './journey'
import Process from './process'
import Services from './servicesnew'
import Testimonial from './testimonial'
import Contact from './contact'
import Contactfooter from './contactfooter'
import Map from './Map'
import { Helmet } from 'react-helmet'
// import WhatsappIcon from './WhatsappIcon'


const Home = () => {
  return (
    <div>
       <Helmet>
        <title>theKrisoft</title>
        <meta
          name="description"
          content="Krisoft provides top-notch Android development services, creating innovative and user-friendly mobile applications."
        />
        <meta
          name="keywords"
          content="Android development, mobile apps, Krisoft, app development, Android solutions"
        />
      </Helmet>
      <HeroSection/>
      <History/>
      <Journey/>
      <Process/>
      <Services/>
      <Testimonial/>
      <Contact/>
      <Map/>
      <Contactfooter/>
    </div>
  )
}

export default Home
